export default "__VITE_ASSET__DsZJfQRr__"